import type { CardCarouselMode } from './cardCarousel.types';

export const getCardCarouselDimensions = (
  mode: CardCarouselMode,
  cardWidthProp: number,
  cardGapDesktop: number,
  width: number
) => {
  // SSR improvement: before the container is measured, use prop values directly so cards render immediately
  if (width === 0) {
    return { cardGap: cardGapDesktop, cardWidth: cardWidthProp };
  }

  let cardWidth = cardWidthProp;
  let cardGap = cardGapDesktop;
  let cardCount;
  const scrollAreaWidthDesktop = width + cardGapDesktop;
  const cardFullWidth = cardWidth + cardGap;

  if (mode === 'max-width') {
    cardCount = Math.ceil(scrollAreaWidthDesktop / cardFullWidth);
    cardWidth = scrollAreaWidthDesktop / cardCount - cardGapDesktop;
  } else if (mode === 'min-width') {
    // Mirrors CSS `repeat(auto-fill, minmax(cardWidth, 1fr))` so rows and grids
    // fit the same number of cards; never rounds up past a whole card, which
    // would shrink cards below `cardWidth`
    cardCount = Math.max(1, Math.floor(scrollAreaWidthDesktop / cardFullWidth));
    cardWidth = scrollAreaWidthDesktop / cardCount - cardGapDesktop;
  } else if (mode === 'ideal-width') {
    const cardCountMin = Math.floor(scrollAreaWidthDesktop / cardFullWidth);
    const cardCountMax = Math.ceil(scrollAreaWidthDesktop / cardFullWidth);
    const cardWidthMin = scrollAreaWidthDesktop / cardCountMin - cardGapDesktop;
    const cardWidthMax = scrollAreaWidthDesktop / cardCountMax - cardGapDesktop;
    cardCount =
      Math.abs(cardWidthProp - cardWidthMin) <=
      Math.abs(cardWidthProp - cardWidthMax)
        ? cardCountMin
        : cardCountMax;
    cardWidth = scrollAreaWidthDesktop / cardCount - cardGapDesktop;
  } else if (mode === 'min-gap') {
    cardCount = Math.floor(scrollAreaWidthDesktop / cardFullWidth);
    if (cardCount > 1) {
      cardGap =
        cardGap +
        (scrollAreaWidthDesktop - cardFullWidth * cardCount) / (cardCount - 1);
    }
  }

  return { cardGap, cardWidth };
};
